import React from 'react'
import { connect } from 'react-redux';
import { Modal, Button, Popconfirm } from 'antd';
import { languageSelector } from '../../../../Redux/Reducers/settingsReducer';
import { localization } from '../../../../Utils/Localization/localization';
import {
  adminsEditStatusSelector,
  removeAdmin,
  updateLevelAdmin
} from '../../../../Redux/Reducers/adminsReducer';
import { SelectLevel } from './SelectLevel';

interface StateProps {
  language: string,
  status: string
}
interface DispatchProps {
  updateLevelAdmin: (id: number, level: number) => void,
  removeAdmin: (id: number) => void
}
interface Props extends StateProps, DispatchProps {
  handleVisible: () => void,
  resetCurrentAdmin: () => void,
  visible: boolean,
  initialLevel: number,
  currentAdmin: number
}

function AdminEdit(props: Props) {
  const [currentAdminLevel, setCurrentAdminLevel] = React.useState(props.initialLevel);

  React.useEffect(() => {
    if (props.status === 'valid') {
      props.handleVisible();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.status]);

  function handleSubmit() {
    if (currentAdminLevel !== props.initialLevel) {
      props.updateLevelAdmin(props.currentAdmin, currentAdminLevel);
    } else {
      props.handleVisible();
    }
  }

  function handleRemove() {
    props.resetCurrentAdmin();
    props.removeAdmin(props.currentAdmin);
  }

  return (
    <Modal
      onOk={handleSubmit}
      onCancel={props.handleVisible}
      title={localization('edit', props.language)}
      visible={props.visible}
      footer={[
        <Button
          onClick={props.handleVisible}
          key='back'
        >
          {localization('cancel', props.language)}
        </Button>,
        <Button
          onClick={handleSubmit}
          type={'primary'}
          key='submit'
          loading={props.status === 'loading'}
        >
          {localization('done', props.language)}
        </Button>
      ]}
    >
      <SelectLevel
        initialLevel={props.initialLevel}
        onChangeHandler={setCurrentAdminLevel}
      />
      {/* <Select
        defaultValue={props.initialLevel}
        onChange={(value) => setCurrentAdminLevel(value)}
      >
        {[1, 2].map((item) => {
          return (
            <Select.Option
              value={item}
              key={item}
            >
              {item}
            </Select.Option>
          );
        })}
      </Select> */}
      <Popconfirm
        title={localization('delete', props.language) + '?'}
        onConfirm={handleRemove}
      >
        <Button
          type={'danger'}
        >
          {localization('delete', props.language)}
        </Button>
      </Popconfirm>
    </Modal>
  );
}

function mapStateToProps(state: any) {
  return {
    language: languageSelector(state),
    status: adminsEditStatusSelector(state)
  }
}
const mapDispatchToProps = {
  updateLevelAdmin,
  removeAdmin
}

const ConnectedAdminEdit = connect(mapStateToProps, mapDispatchToProps)(AdminEdit);
export { ConnectedAdminEdit as AdminEdit };